import React from 'react';

export default function TimeSlots({ loading, slots, selected, onSelect, error, onRetry }) {
  if (loading) {
    return (
      <div className="space-y-2">
        <div className="h-11 bg-[#d9d2ca]/50 animate-pulse" />
        <div className="h-11 bg-[#d9d2ca]/50 animate-pulse" />
        <div className="h-11 bg-[#d9d2ca]/50 animate-pulse" />
        <div className="h-11 bg-[#d9d2ca]/50 animate-pulse" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="border border-[#B5876C]/40 p-4">
        <p className="text-sm text-[#2E2C28]">{error}</p>
        {onRetry && (
          <button onClick={onRetry} className="mt-3 text-xs tracking-[0.2em] uppercase text-[#B5876C] hover:underline">Try again</button>
        )}
      </div>
    );
  }

  const anyAvailable = (slots || []).some(s => s.available);
  if (!anyAvailable) {
    return (
      <div className="border border-[#d9d2ca] p-6 text-center">
        <p className="font-serif italic text-lg text-[#57534b]">No availability on this date.</p>
        <p className="text-sm text-[#7a7369] mt-2">Please select another day.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 max-h-[420px] overflow-y-auto pr-1">
      {slots.map(s => (
        <button
          key={s.start_iso}
          disabled={!s.available}
          onClick={() => onSelect(s)}
          data-testid={`slot-${s.label}`}
          className={[
            'h-11 text-sm font-medium tracking-[0.05em] border transition-colors',
            s.available
              ? (selected && selected.start_iso === s.start_iso
                  ? 'bg-[#B5876C] text-[#EBE4DE] border-[#B5876C]'
                  : 'border-[#B5876C]/40 text-[#2E2C28] hover:bg-[#B5876C] hover:text-[#EBE4DE] hover:border-[#B5876C] cursor-pointer')
              : 'border-[#d9d2ca] text-[#c0b8ac] line-through cursor-not-allowed'
          ].join(' ')}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
